import axios from "axios";

async function getData(url, otherData = {}) {
  try {
    const { data } = await axios.get(`/apis/${url}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      ...otherData,
    });
    return data;
  } catch (error) {
    return { isSuccess: false, msg: error.message || error };
  }
}

async function postData(url, payload, method = "POST") {
  try {
    const { data } = await axios({
      method: method,
      url: `/apis/${url}`,
      data: payload,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return data;
  } catch (error) {
    return { isSuccess: false, msg: error.message || error };
  }
}

export { getData, postData };
